import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 210,
	height: 95,
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	overflow: "hidden",
	viewBox: "0 0 165 75",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(-1999 -1992)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M2039.92 1994.02C2049.45 1994.07 2057.07 2013.99 2056.95 2038.51 2056.84 2062.12 2049.55 2081.57 2040.38 2082.77",
				stroke: "#46B1E1",
				strokeWidth: 2.29167,
				strokeMiterlimit: 8,
				fill: "none",
				fillRule: "evenodd"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2080.71 2010.61C2086.67 2029.58 2085.47 2057.55 2078.03 2073.09 2075.15 2079.1 2071.61 2082.6 2067.93 2083.08",
				stroke: "#46B1E1",
				strokeWidth: 2.29167,
				strokeMiterlimit: 8,
				fill: "none",
				fillRule: "evenodd"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2112.96 2011C2119.05 2029.7 2118.03 2057.72 2110.7 2073.58 2107.78 2079.89 2104.15 2083.57 2100.36 2084.06",
				stroke: "#46B1E1",
				strokeWidth: 2.29167,
				strokeMiterlimit: 8,
				fill: "none",
				fillRule: "evenodd"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2130.74 1996.04C2140.27 1996.09 2147.9 2016.01 2147.78 2040.53 2147.66 2064.14 2140.38 2083.59 2131.21 2084.79",
				stroke: "#46B1E1",
				strokeWidth: 2.29167,
				strokeMiterlimit: 8,
				fill: "none",
				fillRule: "evenodd"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2163.47 1994.81C2173 1994.86 2180.63 2014.77 2180.5 2039.3 2180.39 2062.91 2173.11 2082.36 2163.93 2083.55",
				stroke: "#46B1E1",
				strokeWidth: 2.29167,
				strokeMiterlimit: 8,
				fill: "none",
				fillRule: "evenodd"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 0 172.644 0.036811",
				stroke: "#46B1E1",
				strokeWidth: 2.29167,
				strokeMiterlimit: 8,
				fill: "none",
				fillRule: "evenodd",
				transform: "matrix(0.999988 0.00494362 0.00494362 -0.999988 2030.51 2059.28)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 0 172.644 0.036811",
				stroke: "#46B1E1",
				strokeWidth: 2.29167,
				strokeMiterlimit: 8,
				fill: "none",
				fillRule: "evenodd",
				transform: "matrix(0.999988 0.00494362 0.00494362 -0.999988 2033.34 2027.16)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2027.59 2008 2079.2 2008.66",
				stroke: "#46B1E1",
				strokeWidth: 2.29167,
				strokeMiterlimit: 8,
				fill: "none",
				fillRule: "evenodd"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2123.9 2006.95 2199.81 2009.2",
				stroke: "#46B1E1",
				strokeWidth: 2.29167,
				strokeMiterlimit: 8,
				fill: "none",
				fillRule: "evenodd"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2016.95 1994.94 2074.3 1995.23",
				stroke: "#215F9A",
				strokeWidth: 4.58333,
				strokeMiterlimit: 8,
				fill: "none",
				fillRule: "evenodd"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2072.81 1994.47C2075 1996.84 2077.18 1999.21 2078.24 2001.58 2079.31 2003.94 2078.05 2007.69 2079.2 2008.66 2080.35 2009.63 2083.26 2006.96 2085.17 2007.4 2087.07 2007.84 2088.87 2010.74 2090.61 2011.29 2092.34 2011.83 2094.25 2011.84 2095.58 2010.67 2096.91 2009.5 2097.1 2004.24 2098.59 2004.25 2100.08 2004.26 2102.62 2009.52 2104.52 2010.71 2106.41 2011.9 2108.73 2012.67 2109.98 2011.38 2111.22 2010.1 2110.51 2004.63 2112 2003.03 2113.5 2001.43 2116.98 2001.12 2118.96 2001.78 2120.95 2002.43 2121.67 2006.72 2123.9 2006.95 2126.14 2007.17 2131.36 2005.06 2132.36 2003.13 2133.37 2001.2 2130.66 1996.69 2129.92 1995.4",
				stroke: "#215F9A",
				strokeWidth: 4.58333,
				strokeMiterlimit: 8,
				fill: "none",
				fillRule: "evenodd"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2131.13 1994.65 2188.49 1994.93",
				stroke: "#215F9A",
				strokeWidth: 4.58333,
				strokeMiterlimit: 8,
				fill: "none",
				fillRule: "evenodd"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 0 172.644 0.036811",
				stroke: "#215F9A",
				strokeWidth: 4.58333,
				strokeMiterlimit: 8,
				fill: "none",
				fillRule: "evenodd",
				transform: "matrix(0.999988 0.00494362 0.00494362 -0.999988 2016.51 2083.74)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2001.58 2039.27C2001.7 2014.75 2008.58 1994.9 2016.95 1994.94 2025.31 1994.99 2031.99 2014.9 2031.87 2039.42 2031.75 2063.94 2024.87 2083.79 2016.51 2083.74 2008.14 2083.7 2001.46 2063.79 2001.58 2039.27Z",
				stroke: "#215F9A",
				strokeWidth: 4.58333,
				strokeMiterlimit: 8,
				fill: "none",
				fillRule: "evenodd"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2188.89 1995.79C2198.42 1995.84 2206.05 2015.76 2205.92 2040.28 2205.81 2063.9 2198.53 2083.34 2189.35 2084.54",
				stroke: "#215F9A",
				strokeWidth: 4.58333,
				strokeMiterlimit: 8,
				fill: "none",
				fillRule: "evenodd"
			})
		]
	})
});
export default SvgIcon;
